<!-- <form [formGroup]="form">
  <mat-form-field floatLabel="always" [appearance]="appearance">
    <mat-label *ngIf="!required" [innerHtml]="label| HTMLFormatter"></mat-label>
    <mat-label *ngIf="required" class="req" [innerHtml]="label| HTMLFormatter"></mat-label>
    <mat-label *ngIf="verification_required" style="float: right;font-weight: bold;color: #000;">
      <i *ngIf="verified_status == 1" title="Verified" class="fa fa-check-circle-o"
        style="pointer-events:visible !important;color: green;" aria-hidden="true"></i>
      <i *ngIf="!verified_status || verified_status == 2" title="Not Verified" class="fa fa-times-circle-o"
        [ngClass]="{'pr-3':notes}" style="pointer-events:visible !important;color: red;" aria-hidden="true"></i>
      <i *ngIf="notes" [title]="notes?notes:''" style="pointer-events:visible !important;"
        class="fa fa-commenting-o pr-3"></i>
      <i *ngIf="reason && verified_status == 2" [title]="reason?reason:''" style="pointer-events:visible !important;"
        class="fa fa-info"></i>
    </mat-label>
    <input (click)="openPicker(1)" matInput [matDatetimepicker]="picker" [formControl]="date" [min]="minValue"
      [max]="maxValue" [placeholder]="placeholder" autocomplete="false" (dateChange)="addEvent($event)"
      [readonly]="disabled" [name]="random_id">
    <span class="pointer" *ngIf="form && form.get(controlName) && form.get(controlName).value && !required && !disabled"
      style="position: absolute; right: 0;" (click)="removeDate($event)">
      <i class="fa fa-times"></i>
    </span>
    <mat-error *ngIf="date.hasError('required');else maxvalue">
      Field is mandatory

    </mat-error>
    <ng-template #maxvalue>
      <mat-error *ngIf="date.hasError('matDatepickerMax');else minvalue">
        Value must be lesser than {{maxValue | date: 'd-MMM-yyyy h:mm a'}}
      </mat-error>
    </ng-template>
    <ng-template #minvalue>
      <mat-error *ngIf="date.hasError('matDatepickerMin')">
        Value must be greater than {{minValue | date: 'd-MMM-yyyy h:mm a'}}
      </mat-error>
    </ng-template>
    <mat-datetimepicker-toggle matSuffix [for]="picker" [hidden]="disabled"></mat-datetimepicker-toggle>
    <mat-datetimepicker #picker type="datetime" timeInterval="5" mode="portrait" disabled="false" [hidden]="disabled">
    </mat-datetimepicker>

  </mat-form-field>
</form> -->
<form [formGroup]="form">
  <mat-form-field floatLabel="always" [appearance]="appearance">
    <mat-label *ngIf="!required" [innerHtml]="label| HTMLFormatter"></mat-label>
    <mat-label *ngIf="required" class="req" [innerHtml]="label| HTMLFormatter"></mat-label>
    <mat-label *ngIf="verification_required" style="float: right;font-weight: bold;color: #000;">
      <i *ngIf="verified_status == 1" title="Verified" class="fa fa-check-circle-o"
        style="pointer-events:visible !important;color: green;" aria-hidden="true"></i>
      <i *ngIf="!verified_status || verified_status == 2" title="Not Verified" class="fa fa-times-circle-o"
        [ngClass]="{'pr-3':notes}" style="pointer-events:visible !important;color: red;" aria-hidden="true"></i>
      <i *ngIf="notes" [title]="notes?notes:''" style="pointer-events:visible !important;"
        class="fa fa-commenting-o pr-3"></i>
      <i *ngIf="reason && verified_status == 2" [title]="reason?reason:''" style="pointer-events:visible !important;"
        class="fa fa-info"></i>
    </mat-label>
    <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date" [formControl]="date" [min]="minValue"
      [max]="maxValue" [disabled]="disabled" (dateChange)="addEvent($event)" [readonly]="disabled" [name]="random_id">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="false" [stepHour]="true" [stepMinute]="true"
      [stepSecond]="true" [touchUi]="false" [color]="'primary'" [enableMeridian]="true" [disableMinute]="false"
      [hideTime]="false">
    </ngx-mat-datetime-picker>
  </mat-form-field>
</form>

<!-- <form [formGroup]="group">
  <mat-form-field>
    <mat-label>Start DateTime</mat-label>
    <mat-datetimepicker-toggle [for]="datetimePicker" matSuffix></mat-datetimepicker-toggle>
    <mat-datetimepicker #datetimePicker type="datetime" openOnFocus="true" timeInterval="5" mode="portrait"></mat-datetimepicker>
    <input matInput formControlName="datetimeCtrl" [matDatetimepicker]="datetimePicker" required autocomplete="false">
  </mat-form-field>
</form> -->
